import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name"];
import { cloneElement } from 'react';
import TicketSummaryModal from 'flow/components/tickets/Ai/TicketSummaryModal';
import TicketTagsModal from 'flow/components/tickets/Ai/TicketTagsModal';
import CallTranscriptModal from 'flow/components/tickets/event-item/CallTranscriptModal';
import TicketCreateViaQueueCallModal from 'flow/components/tickets/Creation/TicketCreateViaQueueCallModal';
import TicketAttachmentNotAllowedDialog from 'flow/components/tickets/Input/Attachments/NotAllowedDialog/TicketAttachmentNotAllowedDialog';
import TicketOverviewModal from 'flow/components/tickets/TicketOverviewModal';
import AddTicketMembersModal from 'flow/components/tickets/ticket-details/AddMembers/AddTicketMembersModal';
import TicketMembersModal from 'flow/components/tickets/ticket-info-section/members/TicketMembersModal';
import TicketAccessModal from 'flow/components/tickets/ticket-info-section/access/TicketAccessModal';
import PremadeAnswerTicketModal from 'flow/components/tickets/PremadeAnswerTicketModal';
import WhatsAppTemplateModal from 'flow/components/tickets/WhatsAppTemplateModal';
import { useModal } from 'flow/contexts/ModalProvider';
import ChatPostModal from 'flow/pages/messages/ChatPostModal';
import ImagePreviewModal from 'flow/pages/messages/ImagePreviewModal';
import ChatSummaryModal from './ChatSummaryModal';
import GenerateChatSummaryModal from './GenerateChatSummaryModal';
import DashboardCreatedDialog from '../dashboard/DashboardCreatedDialog';
import AddLiveChatMemberModal from './AddLiveChatMemberModal';
import AddMessageMemberModal from './AddMessageMemberModal';
import AddQueueMemberModal from './AddQueueMemberModal';
import AddQueueWaveMemberModal from './AddQueueWaveMemberModal';
import AddVideoParticipantModal from './AddVideoParticipantModal';
import ArchivedChatsModal from './ArchivedChatsModal';
import CallRecordContactModal from './CallRecordContactModal';
import ContactModal from './ContactModal';
import TicketContactModal from './TicketContactModal';
import CreateCalendarEventModal from './CreateCalendarEventModal';
import CreateCallRoutingModal from './CreateCallRoutingModal';
import CreateContactModal from './CreateContactModal';
import CreateMeetingRoomModal from './VideoMeetingRoom/CreateMeetingRoomModal';
import RoomCreatedModal from './VideoMeetingRoom/RoomCreatedModal';
import CreateFlowFreeProfileModal from './CreateFlowFreeProfileModal';
import CreatePostModal from './CreatePostModal';
import PremadeAnswerModal from './PremadeAnswerModal';
import CreateProfileModal from './CreateProfileModal';
import CreateTokenModal from './CreateTokenModal';
import CentralSwitchWidgetDialog from './dialogs/CentralSwitchWidgetDialog';
import AccessDeniedDialog from './dialogs/AccessDeniedDialog';
import ConfirmationDialog from './dialogs/ConfirmationDialog';
import CreateTokenSuccessDialog from './dialogs/CreateTokenSuccessDialog';
import DeleteContactDialog from './dialogs/DeleteContactDialog';
import MessageAttachmentTooLargeDialog from './dialogs/MessageAttachmentTooLargeDialog';
import RemoveDialog from './dialogs/RemoveDialog';
import RevokeTokenDialog from './dialogs/RevokeTokenDialog';
import DurationPickerModal from './DurationPickerModal';
import EditCalendarEventModal from './EditCalendarEventModal';
import EditContactModal from './EditContactModal';
import EditSoundModal from './EditSoundModal';
import ImageTicketsModal from './ImageTicketsModal';
import IncomingCallsModal from './IncomingCallsModal';
import InviteColleagueModal from './InviteColleagueModal';
import ListRoomsModal from './ListRoomsModal';
import ManagePublicRoomModal from './ManagePublicRoomModal';
import ManageRoomModal from './ManageRoomModal';
import MobileDataStatisticsModal from './MobileDataStatisticsModal';
import MuteConversationModal from './MuteConversationModal';
import NumberPickerModal from './NumberPickerModal';
import OpeningHourModal from './OpeningHourModal';
import ProfilePickerModal from './ProfilePickerModal';
import ReactionsModal from './ReactionsModal';
import TranscriptionDetailModal from './TranscriptionDetailModal';
import AddAiMode from './AddAiMode';
import CreateSoundModal from './CreateSoundModal';
import EditKeyboardShortcutModal from './EditKeyboardShortcutModal';
import MeetingLobbyOpenInAppDialog from '../dialogs/MeetingLobbyOpenInAppDialog';
import AddExtensionsToAutoCoListenToModal from 'flow/components/central-switch/central-switch-widgets/CoListeningAutoWidgetAlpha/AddExtensionsToAutoCoListenToModal';
import CallRecordDetailModalV2 from './CallRecordDetailModalV2';
import ModalTranscription from './transcription/ModalTranscription';
import ModalTicketStateChangeV2 from './dialogs/ModalTicketStateChangeV2';
import DialogDeleteRecording from 'flow/components/pbx/v2/detail-page/call-event/RecordingContextMenu/DialogDeleteRecording';
import DialogDeleteExtendedTranscription from 'flow/components/pbx/v2/detail-page/call-event/RecordingContextMenu/DialogDeleteExtendedTranscription';
import UserRegionSelectorModal from './UserRegionSelectorModal';
import InstantMeetingModal from './InstantMeetingModal';
import { jsx as _jsx } from "react/jsx-runtime";
export var modalComponents = {
  addLiveChatMember: /*#__PURE__*/_jsx(AddLiveChatMemberModal, {}),
  addQueueMember: /*#__PURE__*/_jsx(AddQueueMemberModal, {}),
  addQueueWaveMember: /*#__PURE__*/_jsx(AddQueueWaveMemberModal, {}),
  listRooms: /*#__PURE__*/_jsx(ListRoomsModal, {}),
  managePublicRoom: /*#__PURE__*/_jsx(ManagePublicRoomModal, {}),
  manageRoom: /*#__PURE__*/_jsx(ManageRoomModal, {}),
  createCallRouting: /*#__PURE__*/_jsx(CreateCallRoutingModal, {}),
  createFlowFreeProfile: /*#__PURE__*/_jsx(CreateFlowFreeProfileModal, {}),
  createProfile: /*#__PURE__*/_jsx(CreateProfileModal, {}),
  premadeAnswer: /*#__PURE__*/_jsx(PremadeAnswerModal, {}),
  premadeAnswerTicket: /*#__PURE__*/_jsx(PremadeAnswerTicketModal, {}),
  muteConversation: /*#__PURE__*/_jsx(MuteConversationModal, {}),
  chatPost: /*#__PURE__*/_jsx(ChatPostModal, {}),
  imageTickets: /*#__PURE__*/_jsx(ImageTicketsModal, {}),
  imagePreview: /*#__PURE__*/_jsx(ImagePreviewModal, {}),
  createPost: /*#__PURE__*/_jsx(CreatePostModal, {}),
  setOpeningHour: /*#__PURE__*/_jsx(OpeningHourModal, {}),
  setProfileUntil: /*#__PURE__*/_jsx(ProfilePickerModal, {}),
  addMessageMember: /*#__PURE__*/_jsx(AddMessageMemberModal, {}),
  archivedChats: /*#__PURE__*/_jsx(ArchivedChatsModal, {}),
  createCalendarEvent: /*#__PURE__*/_jsx(CreateCalendarEventModal, {}),
  createToken: /*#__PURE__*/_jsx(CreateTokenModal, {}),
  createTokenSuccess: /*#__PURE__*/_jsx(CreateTokenSuccessDialog, {}),
  editCalendarEvent: /*#__PURE__*/_jsx(EditCalendarEventModal, {}),
  revokeToken: /*#__PURE__*/_jsx(RevokeTokenDialog, {}),
  numberPicker: /*#__PURE__*/_jsx(NumberPickerModal, {}),
  contactModal: /*#__PURE__*/_jsx(ContactModal, {}),
  callRecordContactModal: /*#__PURE__*/_jsx(CallRecordContactModal, {}),
  ticketContactModal: /*#__PURE__*/_jsx(TicketContactModal, {}),
  createContact: /*#__PURE__*/_jsx(CreateContactModal, {}),
  createMeetingRoom: /*#__PURE__*/_jsx(CreateMeetingRoomModal, {}),
  roomCreated: /*#__PURE__*/_jsx(RoomCreatedModal, {}),
  editContact: /*#__PURE__*/_jsx(EditContactModal, {}),
  inviteColleague: /*#__PURE__*/_jsx(InviteColleagueModal, {}),
  messageAttachmentTooLarge: /*#__PURE__*/_jsx(MessageAttachmentTooLargeDialog, {}),
  mobileDataStatistics: /*#__PURE__*/_jsx(MobileDataStatisticsModal, {}),
  deleteContact: /*#__PURE__*/_jsx(DeleteContactDialog, {}),
  durationPicker: /*#__PURE__*/_jsx(DurationPickerModal, {}),
  transcriptionDetail: /*#__PURE__*/_jsx(TranscriptionDetailModal, {}),
  reactions: /*#__PURE__*/_jsx(ReactionsModal, {}),
  confirmationDialog: /*#__PURE__*/_jsx(ConfirmationDialog, {}),
  accessDenied: /*#__PURE__*/_jsx(AccessDeniedDialog, {}),
  removeDialog: /*#__PURE__*/_jsx(RemoveDialog, {}),
  ticketCreateViaQueueCall: /*#__PURE__*/_jsx(TicketCreateViaQueueCallModal, {}),
  ticketOverview: /*#__PURE__*/_jsx(TicketOverviewModal, {}),
  ticketTags: /*#__PURE__*/_jsx(TicketTagsModal, {}),
  addTicketMembers: /*#__PURE__*/_jsx(AddTicketMembersModal, {}),
  ticketMembers: /*#__PURE__*/_jsx(TicketMembersModal, {}),
  ticketAccess: /*#__PURE__*/_jsx(TicketAccessModal, {}),
  callTranscript: /*#__PURE__*/_jsx(CallTranscriptModal, {}),
  ticketAttachmentNotAllowed: /*#__PURE__*/_jsx(TicketAttachmentNotAllowedDialog, {}),
  ticketSummary: /*#__PURE__*/_jsx(TicketSummaryModal, {}),
  whatsAppTemplate: /*#__PURE__*/_jsx(WhatsAppTemplateModal, {}),
  centralSwitchWidget: /*#__PURE__*/_jsx(CentralSwitchWidgetDialog, {}),
  incomingCall: /*#__PURE__*/_jsx(IncomingCallsModal, {}),
  dashboardCreated: /*#__PURE__*/_jsx(DashboardCreatedDialog, {}),
  addVideoParticipant: /*#__PURE__*/_jsx(AddVideoParticipantModal, {}),
  addAiMode: /*#__PURE__*/_jsx(AddAiMode, {}),
  createSound: /*#__PURE__*/_jsx(CreateSoundModal, {}),
  editSound: /*#__PURE__*/_jsx(EditSoundModal, {}),
  editKeyboardShortcut: /*#__PURE__*/_jsx(EditKeyboardShortcutModal, {}),
  openMeetingInApp: /*#__PURE__*/_jsx(MeetingLobbyOpenInAppDialog, {}),
  generateChatSummary: /*#__PURE__*/_jsx(GenerateChatSummaryModal, {}),
  chatSummary: /*#__PURE__*/_jsx(ChatSummaryModal, {}),
  addExtensionsToAutoCoListenToModal: /*#__PURE__*/_jsx(AddExtensionsToAutoCoListenToModal, {}),
  callRecordDetailV2: /*#__PURE__*/_jsx(CallRecordDetailModalV2, {}),
  ticketStateChangeV2: /*#__PURE__*/_jsx(ModalTicketStateChangeV2, {}),
  transcription: /*#__PURE__*/_jsx(ModalTranscription, {}),
  deleteRecording: /*#__PURE__*/_jsx(DialogDeleteRecording, {}),
  deleteTranscription: /*#__PURE__*/_jsx(DialogDeleteExtendedTranscription, {}),
  userRegionSelectorModal: /*#__PURE__*/_jsx(UserRegionSelectorModal, {}),
  instantMeeting: /*#__PURE__*/_jsx(InstantMeetingModal, {})
};
var Modals = function Modals() {
  var _useModal = useModal(),
    modals = _useModal.modals;
  if (!modals.length) {
    return null;
  }
  var _modals = modals[modals.length - 1],
    name = _modals.name,
    rest = _objectWithoutProperties(_modals, _excluded);
  return /*#__PURE__*/cloneElement(modalComponents[name], rest);
};
export default Modals;